import { MouseEvent, useEffect, useState } from 'react';
import Button1 from '../../Components/UI/Button1/Button1';
import { CheckBox } from '../../Components/UI/Input/CheckBox';
import { Input } from '../../Components/UI/Input/Input';
import Select from '../../Components/UI/Select/Select';
import classes from './Edit.module.css'
import { IUser, IUserEdit } from '../../Intarfaces/IUser';
import { IRegForm, IRegFormError } from '../../Intarfaces/IReg';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../Store/store';
import RegAPI from '../../API/RegAPI';
import FullSpaseLoader from '../../Components/UI/Loader/FullSpaseLoader';
import Button2 from '../../Components/UI/Button2/Button2';
import { useNavigate } from 'react-router-dom';
import UserApi from '../../API/UserAPI';
import { setUser } from '../../Store/userSlice';
import educationPlaseholder from '../../helpers/educationPlaseholder';

const minData = new Date(new Date(new Date().setFullYear(new Date().getFullYear()-35)).toISOString().split("T")[0]+"T00:00:00")
const maxData = new Date(new Date(new Date().setFullYear(new Date().getFullYear()-14)).toISOString().split("T")[0]+"T00:00:00") 
const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const regexPhone = /^(\+7|8)[\s\-]?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/;

const Edit = () => {
    const user = useSelector((state:RootState)=>state.user.user)
    const maxActiveLessonId = useSelector((state:RootState)=>state.user.maxActiveLessonId)
    const [form, setForm]=useState<IUserEdit>({...user as IUserEdit, birthday:new Date(user?.birthday as string).toISOString().split("T")[0]}) 

    const [formError, setFormError] = useState({} as IRegFormError)  
    const [isSendFormLoader, setIsSendFormLoader] = useState(false)
    const nav = useNavigate()

    const setValue = (properte:string, value:string) =>{
        console.log(typeof value);
        if(!value &&  properte==="birthday"){
            return;
        }
        setForm({...form,[properte]:value})

    }

    

                

    const validate = (formV:IUserEdit):IRegFormError =>{
          
        const formErrorV = {} as IRegFormError
        formErrorV.countError = 0
        for(let keyI in formV){
            
            switch (keyI){
                case "full_name":
                    if(formV[keyI].length===0){
                        formErrorV.full_name = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    else if(formV[keyI].replace(" ",'').length<2){
                        formErrorV.full_name = "Некорректные данные"
                        formErrorV.countError++
                    }
                    break;
                case "birthday":
                    console.log(formV[keyI]);
                    
                    if(formV[keyI].length===0){
                        formErrorV.birthday = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    else if(!(new Date(formV[keyI]+'T00:00:00').getTime()>=minData.getTime() && new Date(formV[keyI]+'T00:00:00').getTime()<=maxData.getTime())){
                        formErrorV.birthday = "Возраст участника должен быть от 18 до 35 лет"
                        formErrorV.countError++
                    }
                    break;
                case "status":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.status = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
                case "organization":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.organization = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
                case "education":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.education = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
                case "education_name":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.education_name = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    break;
                case "phone":
                    if(formV[keyI].replace(" ",'').length===0){
                        formErrorV.phone = "Данное поле обязательно к заполнению"
                        formErrorV.countError++
                    }
                    else if(!regexPhone.test(formV[keyI])){
                        formErrorV.phone = "Некоректный номер телефона"
                        formErrorV.countError++
                    }
                    break;
            }

        }
        

        return formErrorV

    }
 

    const dispatch= useDispatch()
    
    const sendForm = async (e:MouseEvent<HTMLButtonElement>) =>{
        e.preventDefault()
        const error = validate(form)
        setFormError(error)

        if(error.countError!==0){
            return;
        }
        
        

        setIsSendFormLoader(true)
        const response = await UserApi.edit(form, maxActiveLessonId)
        setIsSendFormLoader(false)

        setFormError({...formError, globalError:null})

        if(response.status!==200){
            setFormError({...formError, globalError: response.message})
            return;
        }

        dispatch(setUser({...user as IUser,...form}))

        nav('/accaunt')
        


    }


    return ( 
        <div className={classes.edit}>
            <FullSpaseLoader isLoader={isSendFormLoader} />
            <div className={classes.container}>
                <div className={classes.title}>
                    Редактирование профиля
                </div>
                <form>
                <div className={classes.inputs}>
                        <div className={classes.input}>
                            <Input placeholder='ФИО' value={form.full_name} onChange={(e)=>setValue('full_name', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.full_name}
                            </div>
                        </div>
                        <div className={classes.input}>
                            
                            <Input 
                            type={"date"} 

                            min={minData.toISOString().split("T")[0]} 
                            max={maxData.toISOString().split("T")[0]}
 
                            placeholder='Дата рождения' 

                            defaultValue={new Date(form.birthday).toISOString().split("T")[0] }  

                            onChange={(e)=>setValue('birthday', e.target.value)}/>

                            <div className={classes.error}>
                                {formError.birthday}
                            </div>
                        </div>
                        
                        <div className={classes.input}>
                            <Select value={form.status} onChange={(e)=>setValue('status', e.target.value)}>
                                <option value="">--Статус--</option>
                                <option value="студент">Студент</option>
                                <option value="аспирант">Аспирант</option>
                                <option value="сотрудник">Сотрудник</option>
                            </Select>
                            <div className={classes.error}>
                                {formError.status}
                            </div>
                        </div>
                        <div className={classes.input}>
                            <Input placeholder='Наименование организации' value={form.organization} onChange={(e)=>setValue('organization', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.organization}
                            </div>
                        </div>
                        <div className={classes.input}>
                            <Select value={form.education} onChange={(e)=>setValue('education', e.target.value)}>
                                <option value="">--Профиль обучения--</option>
                                <option value="факультет">Факультет</option>
                                <option value="институт">Институт</option>
                                <option value="высшая школа">Высшая школа</option>
                                <option value="вертикаль">Вертикаль</option>
                            </Select>
                            <div className={classes.error}>
                                {formError.education}
                            </div>
                        </div>
                        {
                            form.education!==""?
                            <div className={classes.input}>
                                <Input placeholder={educationPlaseholder(form.education)} value={form.education_name} onChange={(e)=>setValue('education_name', e.target.value)}/>
                                <div className={classes.error}>
                                    {formError.education_name}
                                </div>
                            </div>
                            :
                            <></>

                        }
                        
                        <div className={classes.input}>
                            <Input placeholder='Номер телефона' value={form.phone} onChange={(e)=>setValue('phone', e.target.value)}/>
                            <div className={classes.error}>
                                {formError.phone}
                            </div>
                        </div>
                    </div>
                    <div className={classes.input}>
                        <div className={classes.error}>
                            {formError.globalError}
                        </div>
                    </div>
                    <div className={classes.buttons}>
                    <Button2 onClick={(e)=>{e.preventDefault();nav('/accaunt')}} style={{marginTop:"15px"}}>
                        Отмена
                    </Button2>
                    <Button1 onClick={(e)=>sendForm(e)} style={{marginTop:"15px"}}>
                        Сохранить
                    </Button1>
                    </div>
                    
                </form>
                <div style={{minHeight:"90px"}}/>
            </div>
        </div>
     );
}
 
export default Edit;